import React from "react";
import * as Mui from "@mui/material";
import { DashboardLayout } from "component/layout/dashboard";
import { JavaIframe } from "component/shared/iframe/java";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const { user } = this.props;
		const title = "Reports Overview";
		return (
			<DashboardLayout
				permitted={user && user.permissions.reporting}
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.BarChart2 />
						</FeatherIcon>
						{title}
					</Mui.Typography>
				}
				iframe={<JavaIframe url="/reports/overview" />}
			/>
		);
	}

}

export const ReportsOverviewPage = Component;